__turbopack_context__.v({
  "singleRecommendation": "HomepageSliceHandler-module-scss-module__VQ_Wyq__singleRecommendation",
});
